import { states } from './countries';

export const getStateAbbreviation = (stateName: string): string => {
  const state = states.find(s => s.name.toLowerCase() === stateName.toLowerCase());
  return state?.code || stateName;
}; 